import { axios } from '@/api/axios.config'
import { api } from '@/utils/global/api'

const v2Api = api.replace(/v1\/?$/, 'v2/')

/** One add-on option the send-proof modal can suggest to the client. */
export type DesignerProofAddOn = {
  optionId: string
  customizationId: string
  label: string
  description: string | null
  priceCents: number
  durationMinutes: number
  // True when the line already carries the service — the modal hides
  // these rows instead of offering them again.
  alreadySelected: boolean
}

/**
 * The add-on options the designer's send-proof modal lists, authorized by
 * the designer edit token.
 */
export const getDesignerProofContext = async (token: string) => {
  const response = await axios.get<{ addOns: DesignerProofAddOn[] }>(
    `${v2Api}design-requests/proof-context/${token}`,
  )
  return response.data
}

/**
 * Sends the proof to the client: the backend enqueues the digital-proof
 * screenshot job and posts the proof (with any suggested add-ons) onto the
 * design request once the images exist.
 */
export const sendDesignerProof = async (payload: {
  token: string
  note: string
  suggestedOptionIds: string[]
  // A completed proof render to reuse instead of enqueuing a new one.
  reusePdfRecordId?: string
}) => {
  const response = await axios.post<{ pdfRecordId: string; reused?: boolean }>(
    `${v2Api}design-requests/send-proof`,
    payload,
  )
  return response.data
}
